import * as THREE from 'three';

const EPSILON = 0.01;

/**
 * Wire'ın geometrisindeki ardışık duplicate vertex'leri temizler.
 * Sıfır-uzunluklu segmentleri ortadan kaldırır → gizmo'ların üst üste binmesi
 * ve panel exit point üzerinde stack'lenmiş vertex görünümü engellenir.
 *
 * @param {THREE.Line} wire — wire objesi (geometry'si BufferGeometry olmalı)
 * @returns {number} silinen duplicate vertex sayısı
 */
export function dedupWireVertices(wire) {
  if (!wire || !wire.isLine) return 0;
  const pos = wire.geometry?.attributes?.position;
  if (!pos || pos.count < 2) return 0;

  const verts = [];
  verts.push([pos.getX(0), pos.getY(0), pos.getZ(0)]);
  for (let i = 1; i < pos.count; i++) {
    const x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i);
    const last = verts[verts.length - 1];
    if (Math.abs(x - last[0]) < EPSILON && Math.abs(y - last[1]) < EPSILON) continue;
    verts.push([x, y, z]);
  }
  if (verts.length === pos.count) return 0;
  if (verts.length < 2) return 0; // güvenlik: tek vertex'e düşme

  const arr = new Float32Array(verts.length * 3);
  for (let i = 0; i < verts.length; i++) {
    arr[i * 3] = verts[i][0];
    arr[i * 3 + 1] = verts[i][1];
    arr[i * 3 + 2] = verts[i][2];
  }
  wire.geometry.setAttribute('position', new THREE.BufferAttribute(arr, 3));
  wire.geometry.attributes.position.needsUpdate = true;
  wire.geometry.computeBoundingBox();
  wire.geometry.computeBoundingSphere();
  if (typeof wire.computeLineDistances === 'function') wire.computeLineDistances();
  return pos.count - verts.length;
}

// Wire-benzeri Line objesi mi? Panel yapısal çizgilerini ve title group line'larını dışarıda bırakır.
function isWireLikeForDedup(obj) {
  if (!obj.isLine) return false;
  const ud = obj.userData || {};
  if (ud.isPanelPart) return false;
  if (ud.type === 'wireTitle') return false;
  if (ud.lineType === 'frontEdge') return false;
  if (ud.role === 'wireMarker') return false;
  if (ud.type && /wire/i.test(ud.type)) return true;
  if (ud.feederId || ud.wireId || ud.wireID) return true;
  if (ud.isWire === true) return true;
  return false;
}

/**
 * Sahnedeki tüm wire'ları tarar ve duplicate vertex'leri temizler.
 * @param {THREE.Scene} scene
 * @returns {{ wiresChanged: number, verticesRemoved: number }}
 */
export function dedupAllWiresInScene(scene) {
  if (!scene) return { wiresChanged: 0, verticesRemoved: 0 };
  let wiresChanged = 0;
  let verticesRemoved = 0;
  scene.traverse(obj => {
    if (!isWireLikeForDedup(obj)) return;
    const removed = dedupWireVertices(obj);
    if (removed > 0) {
      wiresChanged++;
      verticesRemoved += removed;
    }
  });
  return { wiresChanged, verticesRemoved };
}
